import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography,
  Checkbox,
  Paper,
} from "@mui/material";
import { Grid, Stack } from "@mui/system";
import CheckIcon from "@mui/icons-material/Check";
import DataStatusAlert from "../../../../Health/DataAccuracy/UI_HelpersOf_DataAccuracy/DataStatusAlert_Helpers";
import { useSelector } from "react-redux";
import { useState } from "react";
import SaveIcon from "@mui/icons-material/Save";
import { useDispatch } from "react-redux";
import { setSelectedRows } from "../../../../../../features/actionItemsSlice";
import { useUpdateAcionItemsStatus } from "../../../../../../customHooks/useUpdateAcionItemsStatus";

const ResolveAction = ({
  open,
  handleClose,
}: {
  open: boolean;
  handleClose: () => void;
}) => {
  const { selectedRows } = useSelector((state: any) => state?.actionItems);
  const { loading, updateActionItemsStatus } =
    useUpdateAcionItemsStatus("resolved"); // Custom hook for updating status(Resolved)
  const [comment, setComment] = useState<string>("");
  const [selected, setSelected] = useState<any[]>(selectedRows);
  const dispatch = useDispatch();

  // Check if all rows are selected
  const isAllSelected = selected.length === selectedRows.length;

  // Handle individual row selection
  const handleSelectRow = (row: any) => {
    setSelected((prev) =>
      prev.some((r) => r === row)
        ? prev.filter((r) => r !== row)
        : [...prev, row]
    );
  };

  // Handle "Select All" checkbox
  const handleSelectAll = () => {
    setSelected(isAllSelected ? [] : [...selectedRows]);
  };

  //-- Close the Resolve modal and clear the selected rows(unchecked checkboxes)
  const handleCloseResolveModal = () => {
    handleClose(); // Close modal if success
    dispatch(setSelectedRows([])); // Clear selected rows
  };

  //-- Request body for updating task status Resolved
  const resolveBodyActionItem = {
    tasks: selected.map((task) => ({
      shared_uid: task.shared_uid,
      current_status: "Done",
    })),
  };

  //-- Clicking the Resolve button
  const handleActions = async () => {
    if (selected.length === 0) return;
    //-- this function for update status(MAKE API call for update status)
    updateActionItemsStatus(
      resolveBodyActionItem,
      comment,
      handleCloseResolveModal
    );
  };

  return (
    <Dialog
      open={open}
      onClose={(_, reason) => {
        // Prevent close if loading and the reason is backdrop click or escape key
        if (
          loading &&
          (reason === "backdropClick" || reason === "escapeKeyDown")
        ) {
          return;
        }
        handleCloseResolveModal();
      }}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle>Resolve Action Items</DialogTitle>
      <DialogContent>
        <Typography gutterBottom sx={{ paddingBottom: "8px" }}>
          Selected Items
        </Typography>
        <Paper
          sx={{
            width: "100%",
            overflowY: "auto",
            height: "auto",
            maxHeight: "225px",
            scrollbarWidth: "thin",
          }}
        >
          <Table size="small" aria-label="a dense table">
            <TableHead>
              <TableRow>
                <TableCell padding="checkbox" sx={{ padding: "4px" }}>
                  <Checkbox
                    size="small"
                    color="secondary"
                    checked={isAllSelected}
                    onChange={handleSelectAll}
                  />
                </TableCell>
                <TableCell sx={{ padding: "4px" }}>Item Name</TableCell>
                <TableCell sx={{ padding: "4px" }}>Target</TableCell>
                <TableCell sx={{ padding: "4px" }}>Status</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {selectedRows?.map((row: any, index: number) => (
                <TableRow
                  key={index}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell padding="checkbox" sx={{ padding: "4px" }}>
                    <Checkbox
                      size="small"
                      color="secondary"
                      checked={selected.some((r) => r === row)}
                      onChange={() => handleSelectRow(row)}
                    />
                  </TableCell>
                  <TableCell sx={{ padding: "4px" }}>
                    {row?.data["action_item"]}
                  </TableCell>
                  <TableCell sx={{ padding: "4px" }}>
                    {row?.data["target"]}
                  </TableCell>
                  <TableCell sx={{ padding: "4px" }}>
                    {row?.current_status && (
                      <DataStatusAlert status={row?.current_status} />
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Paper>
        <Typography gutterBottom marginBlock={2}>
          Add Comment
        </Typography>
        <Grid container>
          <Grid size={12}>
            <TextField
              color="secondary"
              fullWidth
              id="outlined-multiline-static"
              label="Content"
              placeholder="Explain why or how this task is resolved"
              multiline
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              rows={4}
              //required={selected?.length > 1}
              required
              helperText="This field is mandatory"
              slotProps={{
                inputLabel: {
                  shrink: true,
                },
              }}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions sx={{ padding: "20px" }}>
        <Button
          onClick={() => {
            handleClose();
            dispatch(setSelectedRows([]));
          }}
          color="secondary"
          disabled={loading}
        >
          Cancel
        </Button>
        <Button
          data-tracker="115"
          variant="contained"
          color="secondary"
          loading={loading}
          loadingPosition="end"
          endIcon={loading && <SaveIcon />}
          //disabled={selected.length === 0 || (selected.length > 1 && !comment)}
          disabled={selected.length === 0 || !comment}
          onClick={() => handleActions()}
        >
          <Stack direction="row" alignItems="center" gap={1}>
            Resolve
            <CheckIcon fontSize="small" />
          </Stack>
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ResolveAction;
